// extracted by mini-css-extract-plugin
export default {"title":"Vsm6lH","mobile":"L6cA76"};